<template>
        <div id='goodslist'>
              <NavTop title='订货区'/>
              <div class='maincon'>
                  <div class="goodsitem" v-for="item in goodslist" :key="item.id">
                      <div class="goodsitem-row">
                        <div class="goodsitem-col1"><img :src='item.headimg' @click='goDetail(item.id)'/></div>
                        <div class="goodsitem-col2">
                            <div class="goodsitem-col2-line1">{{item.name}}</div>
                            <div class="goodsitem-col2-line2">库存数:{{item.stock}}</div>
                            <div class="goodsitem-col2-line2"></div>
                            <div class="goodsitem-col2-line3">
                                <div class="goodsprice">¥{{item.nowprice}}</div>
                                <div class="goodsnums"><GoodsNums :item='item'/></div>
                            </div>
                        </div>
                      </div>
                  </div>
              </div>
              <div class="bottomcon">
                  <div class="bottomcon-left"><div class="goodswords">优惠总价:</div><div class="goodsprice">¥{{carttotal}}</div></div>
                  <div class="bottomcon-right">
                      <div class="bottomcon-orderbtn" @click="goOrder">
                          <div class="bottomcon-orderbtn-words">立即订购</div>
                      </div>
                  </div>
              </div>    
        </div>
</template>
<script>
import NavTop from '@/components/navtop'
import GoodsNums from "@/components/goodsnums"
export default {
  name: 'shoplist',
  computed:{
      goodslist(){
        return this.$store.state.cart.goodslist
      },
      carttotal(){
         return this.$store.getters.carttotal(this.$store.state.cart.clicked)
      }
  },  
  created(){
    this.$store.commit('INIT_CART')
    this.$store.commit('INIT_ADDRESS')
    this.getList()
  },
  methods:{
    getList(){
       this.$post("/goods/getGoodsList",{}).then((data)=>{
           if(data.result.success){
               this.$store.commit('INIT_GOODSLIST',{goodslist:data.result.info.goodslist})
               this.$store.commit('INIT_LEVELUPMONEY',{levelupmoney:data.result.info.levelupmoney})
           }else{
               this.$toast(data.result.info)
           }
       })
    }, 
    goOrder(){
        if(this.carttotal<=0){
            this.$toast("请先添加商品")
            return false
        }
        this.$go("/order");
    },
    goDetail(goodsid){
       this.$go("/goodsdetail/"+goodsid)
    } 
  },
  components:{
      NavTop,GoodsNums
  }
}
</script>
<style scoped>
#goodslist{background-color:#F6F6F6;min-height: 100vh;}
.maincon{display: flex;flex-flow: column nowrap;margin-bottom: 150px;padding: 0 0.25rem;}
.goodsitem{display: flex;padding: 0.25rem;background-color: #fff;margin-top: 0.25rem;height: 3.8rem;align-items:center;border:1px solid #e7e7e7;border-radius: 0.15rem;}
.goodsitem-row{display: flex;flex-flow: row nowrap;justify-content: flex-start;width:100%;}
.goodsitem-col1 img{width:2rem;}
.goodsitem-col2 {margin-left: 0.25rem;display: flex; flex-flow: column nowrap;text-align: left;width:100%;}
.goodsitem-col2-line1{font-size: 0.35rem;}
.goodsitem-col2-line2{font-size: 0.3rem;color:#5e5e5e;margin-top: 0.15rem;}
.goodsitem-col2-line3{margin-top: 0.3rem;display: flex;flex-flow: row nowrap;}
.goodsnums{margin-left: auto;}
.goodsprice{color:#ff3600;font-size:0.4rem;display: flex;align-items: center;}
.bottomcon{display: flex;width:100%;background-color:#fff;height: 60px;position: fixed;left:0;bottom: 50px;align-items: center;}
.bottomcon-left{display: flex;padding-left: 0.5rem;}
.goodswords{color:#333;font-size:0.35rem}
.bottomcon-right{margin-left: auto;padding-right: 0.3rem;}
.bottomcon-orderbtn{background-color:#ee0a24;color:#fff;height:1rem;width:3rem;border-radius: 0.15rem;display: flex;flex-flow: column nowrap;justify-content: center;}
.bottomcon-orderbtn-words{font-size:0.35rem;}
</style>


